import { useShowResponseStatus } from '@/shared';
import { useDeletePaymentSystemMutation } from '../store/payment-system-api';
import { handlePaymentSystemDeleteError } from '../utils/helpers/payment-systems-errors';

export const useDeletePaymentSystem = () => {
  const [deletePaymentSystem, { isLoading, isSuccess, error }] = useDeletePaymentSystemMutation();
  const deleteError = handlePaymentSystemDeleteError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Платёжная система успешно удалёна',
    error: deleteError,
  });

  return {
    deletePaymentSystem,
    isLoading,
  };
};
